import { languagesUpperCased as languages } from './languages';

const handleFormLanguageTab = (field = '', tabsInfo = null) => {
  if (!tabsInfo || !field) return null;
  const languageTabObject = {};
  languages.forEach((lang) => {
    if (tabsInfo[`${field}${lang}`]) {
      languageTabObject[lang.toLowerCase()] = tabsInfo[`${field}${lang}`];
    }
  });

  if (Object.keys(languageTabObject).length > 0) {
    return languageTabObject;
  }
  return null;
};

export default handleFormLanguageTab;
